import { z } from 'zod';
/**
 * Empty string and null both normalize to undefined (omit on create); non-empty values must be
 * a UUID of any version. Unlike optionalUuidString, this does not pin to v7 -- use it for a
 * field the client mints itself (e.g. an idempotency key via crypto.randomUUID(), which
 * produces v4), not a foreign key selecting one of this schema's v7-generated primary keys.
 */
export const optionalClientGeneratedUuidString = (invalidMessage) => z
    .string()
    .nullable()
    .transform((value) => (value === '' || value == null ? undefined : value))
    .refine((value) => value === undefined || z.uuid().safeParse(value).success, invalidMessage)
    .optional();
//# sourceMappingURL=optional-client-generated-uuid-string.js.map